import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Card from '@/components/Card';
import { AccentLine } from '@/components/Gauge/styles';

export * from '../styles';

export const CardHeaderRow = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  marginBottom: '16px',
});

export const CardTitleGroup = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center',
  gap: '10px',
});

export const CardTitleText = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  color: theme.palette.white['06'],
}));

export const SpeedCard = styled(Card)({
  width: '100%',
  height: '100%',
  boxSizing: 'border-box',
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
});

export const GaugeCenteredBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  flex: 1,
  width: '100%',
  paddingTop: '16px',
  paddingBottom: '16px',
});

export const GaugeAccentLine = styled(AccentLine)({
  marginTop: '16px',
});

export const PhaseIndicator = styled(Typography, {
  shouldForwardProp: (prop) => prop !== '$type',
})<{ $type?: 'download' | 'upload' }>(({ theme, $type }) => ({
  fontSize: '12px',
  fontWeight: 600,
  color:
    $type === 'upload'
      ? (theme.palette.secondary['02'] ?? theme.palette.warning.main)
      : theme.palette.primary.main,
  letterSpacing: '0.5px',
  animation: 'pulse 1.5s ease-in-out infinite',
  '@keyframes pulse': {
    '0%, 100%': { opacity: 1 },
    '50%': { opacity: 0.4 },
  },
}));
